import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Link from 'next/link';
import Image from 'next/image';
import buyingIcon from '@/public/images/icons/dashboard/shopping-cart.svg';
import dashboardIcon from '@/public/images/icons/dashboard/dashboard.svg';
import sellingIcon from '@/public/images/icons/dashboard/selling.svg';
import portfolioIcon from '@/public/images/icons/dashboard/portfolio.svg';
import wishlistIcon from '@/public/images/icons/dashboard/wishlist.svg';
import lastViewedIcon from '@/public/images/icons/dashboard/file-text.svg';
import vouchersIcon from '@/public/images/icons/dashboard/ticket.svg';
import suggestBottleIcon from '@/public/images/icons/dashboard/suggest-bottle.svg';
import bellIcon from '@/public/images/icons/dashboard/bell.svg';
import settingsIcon from '@/public/images/icons/dashboard/settings.svg';
import languageIcon from '@/public/images/icons/dashboard/language.svg';
import styles from '../../menu.module.scss';
import { SettingsMemoLogoutLink } from '@/components/common/LogoutLinks';
import referrals from '@/public/images/icons/dashboard/referrals.svg';
import { useRouter } from 'next/router';
import event from '@/utilites/gTag';
import DefaultButton from '@/components/common/default/DefaultButton';

const SettingsMenu = ({ userId }: { userId: string | null }) => {
  const router = useRouter();
  const handleClickToPortfolio = () => {
    event(
      'global_to_portfolio_button_click',
      {
        event_category: 'interaction',
        device: 'Website',
      },
      { userId: userId, lang: router.locale }
    );
    router.push('/dashboard/portfolio');
  };

  const handleClickToWishlist = () => {
    event(
      'global_whishlist_button_click',
      {
        event_category: 'interaction',
        device: 'Website',
      },
      { userId: userId, lang: router.locale }
    );
    router.push('/dashboard/wishlist');
  };

  return (
    <Row>
      <Col>
        <ListGroup variant="flush" className={`${styles.dashboardMenu} me-3`}>
          <ListGroup.Item>
            <Link
              href="/dashboard"
              className="d-flex justify-content-start align-items-center"
            >
              <Image src={dashboardIcon} width={24} height={24} alt="Buy" />
            </Link>
          </ListGroup.Item>
          <ListGroup.Item>
            <Link
              href="/dashboard/buying"
              className="d-flex justify-content-start align-items-center"
            >
              <Image src={buyingIcon} width={24} height={24} alt="Buy" />
            </Link>
          </ListGroup.Item>
          <ListGroup.Item>
            <Link
              href="/dashboard/selling"
              className="d-flex justify-content-start align-items-center"
            >
              <Image src={sellingIcon} width={24} height={24} alt="Buy" />
            </Link>
          </ListGroup.Item>
          <ListGroup.Item>
            <DefaultButton
              onClick={handleClickToPortfolio}
              className="tw-flex tw-items-center tw-justify-center tw-w-full tw-py-2"
            >
              <Image src={portfolioIcon} width={24} height={24} alt="Buy" />
            </DefaultButton>
          </ListGroup.Item>
          <ListGroup.Item>
            <DefaultButton
              onClick={handleClickToWishlist}
              className="tw-flex tw-items-center tw-justify-center tw-w-full tw-py-2"
            >
              <Image src={wishlistIcon} width={24} height={24} alt="Buy" />
            </DefaultButton>
          </ListGroup.Item>
          <ListGroup.Item>
            <Link
              href="/dashboard/referrals"
              className="d-flex justify-content-start align-items-center"
            >
              <Image src={referrals} width={24} height={24} alt="Buy" />
            </Link>
          </ListGroup.Item>
          <ListGroup.Item>
            <Link
              href="/dashboard/last-viewed"
              className="d-flex justify-content-start align-items-center"
            >
              <Image src={lastViewedIcon} width={24} height={24} alt="Buy" />
            </Link>
          </ListGroup.Item>
          <ListGroup.Item>
            <Link
              href="/dashboard/vouchers"
              className="d-flex justify-content-start align-items-center"
            >
              <Image src={vouchersIcon} width={24} height={24} alt="Buy" />
            </Link>
          </ListGroup.Item>
        </ListGroup>
        <hr />
        <ListGroup variant="flush" className={`${styles.dashboardMenu} me-3`}>
          <ListGroup.Item>
            <Link
              href="/dashboard/suggest-bottle"
              className="d-flex justify-content-start align-items-center"
            >
              <Image src={suggestBottleIcon} width={24} height={24} alt="Buy" />
            </Link>
          </ListGroup.Item>
        </ListGroup>
        <hr />
        <ListGroup variant="flush" className={`${styles.dashboardMenu} me-3`}>
          <ListGroup.Item>
            <Link
              href="/dashboard/notifications"
              className="d-flex justify-content-start align-items-center"
            >
              <Image src={bellIcon} width={24} height={24} alt="Buy" />
            </Link>
          </ListGroup.Item>
          <ListGroup.Item className={styles.active}>
            <Link
              href="/dashboard/settings"
              className="d-flex justify-content-start align-items-center"
            >
              <Image src={settingsIcon} width={24} height={24} alt="Buy" />
            </Link>
          </ListGroup.Item>
          <ListGroup.Item>
            <div className="d-flex justify-content-start align-items-center">
              <Image src={languageIcon} width={24} height={24} alt="Buy" />
            </div>
          </ListGroup.Item>
        </ListGroup>
        <hr />
        <ListGroup variant="flush" className={`${styles.dashboardMenu} me-3`}>
          <ListGroup.Item>
            <SettingsMemoLogoutLink />
          </ListGroup.Item>
        </ListGroup>
      </Col>
    </Row>
  );
};

export default SettingsMenu;
